import * as yup from "yup"

import { regex } from "constants/regex"
import { stringValidationYup } from "helpers/validations"
import { t } from "i18next"

const getAddReviewValidationSchema = () =>
  yup.object().shape({
    leadId: yup.string().required(t("Lead Id is required")),
    callRecording: stringValidationYup(t("Call recording is required")),
    additionalComment: stringValidationYup(null, regex.alphaNumeric),
    progressOnTask: stringValidationYup(t("Progress on task is required")),
    additionalComment2: stringValidationYup(null, regex.alphaNumeric),
    proposedNextTask: yup.object().required(t("Proposed next task is required")).nullable(),
    feedback: stringValidationYup(t("Feedback is required")),
    addAuditConcernFlag: yup.boolean().required(t("Audit concern selection is required")),
    reviewType: yup.string().required(t("Review type is required")).nullable(),
    clientInterested: yup.string().required(t("Client interest is required")).nullable(),
    clientNotInterestedReasonId: yup.string().required(t("Reason is required")).nullable(),
    clientNotInterestedReasonValue: stringValidationYup(t("Coment is required")).nullable(),
    areasOfImprovementsIds: yup.array().nullable(),
    otherImprovement: stringValidationYup(t("Others is required")).nullable(),
  })

export default getAddReviewValidationSchema
